define(["require", "exports", "@os/os-common/lib/ioc", "@os/os-common/lib/services/OracleGuidedLearningService", "./environment"], function (require, exports, ioc_1, OracleGuidedLearningService_1, environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.showOglPanel = exports.showOgl = exports.oglChangeRoute = exports.oglChangeLanguage = exports.oglInit = void 0;
    const oracleGuidedLearningService = ioc_1.container.get(OracleGuidedLearningService_1.OracleGuidedLearningService);
    const oglInit = (user, oglAppId, page) => {
        oracleGuidedLearningService.init({
            applicationId: oglAppId,
            userId: user.email,
            url: window.location.href,
            pageId: page,
            pageName: page,
            language: user.defaultLanguage,
            route: page,
            env: oglEnv(),
            inIframe: false
        });
    };
    exports.oglInit = oglInit;
    const oglChangeLanguage = (lang) => {
        if (oglInitialized() && iridize) {
            iridize("api.fields.set", { lang });
        }
    };
    exports.oglChangeLanguage = oglChangeLanguage;
    const oglChangeRoute = (route) => {
        if (oglInitialized() && iridize) {
            iridize("api.route.update", { route });
            iridize("api.guide.refresh");
        }
    };
    exports.oglChangeRoute = oglChangeRoute;
    const oglEnv = () => {
        return (0, environment_1.isNonProduction)() ? "dev" : "prod";
    };
    const showOgl = (show) => {
        const styleTagId = "ogl-widget-control";
        const styleTag = document.getElementById(styleTagId);
        if (styleTag) {
            styleTag.remove();
        }
        if (!show) {
            const style = document.createElement("style");
            style.id = styleTagId;
            style.textContent = `
      .ogl-rw-convergence-launcher {
        display: none !important;
      }
    `;
            document.head.appendChild(style);
        }
    };
    exports.showOgl = showOgl;
    const showOglPanel = (show) => {
        if (oglInitialized() && iridize) {
            if (show) {
                iridize("api.startPanel.open");
            }
            else {
                iridize("api.startPanel.close");
            }
        }
    };
    exports.showOglPanel = showOglPanel;
    const oglInitialized = () => document.getElementsByClassName("ogl-rw-convergence-launcher")[0] !== undefined;
});
